<template>
  <v-container>
    <v-row>
      <v-snackbar v-model="snackbar" :timeout="4000" top :color="color" > {{text}}
        <v-btn color="white" text @click="snackbar = false" > Cerrar  </v-btn>
      </v-snackbar>

      <v-card width="100%" height="100%" flat>
        <v-card-title primary-title >
          Catálogo de Usuarios

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar Usuarios"
            single-line
            hide-details
          ></v-text-field>

          <v-spacer></v-spacer>
          
          <!-- NUEVO -->
          <v-btn align="right" 
            color="primary" dark small 
            class="ma-2" 
            :to="{ name: 'newusuario' }" >Nuevo
          </v-btn>

          <!-- BOTON EXCEL -->
          <v-btn 
            class="ma-2" 
            small dark color="warning"
            @click="exportar()">
            <v-icon>save_alt</v-icon>
          </v-btn>

          <v-btn  class="secondary" icon dark @click="init" ><v-icon>refresh</v-icon> </v-btn>

        </v-card-title>
              
        <v-data-table
          :loading="loading"        
          :headers="headers"
          :items="usuarios"
          class="elevation-1"
          fixed-header
          height="450"
          hide-default-footer disable-pagination 
          loading-text="Cargando..."
          dense
          :search="search"
          :items-per-page=200
        >
          <template v-slot:item.nivel="{ item }" >
            <div v-if="item.nivel == 'USUARIO'">Usuario</div>    
            <div v-if="item.nivel == 'ADMIN'">Administrador</div>    
            <div v-if="item.nivel == 'SUPERVISOR'">Supervisor</div>    
          </template>

          <template v-slot:item.estatus="{ item }" >
            <span v-if="item.estatus == 2" class="green--text">ACTIVO</span>
            <span v-if="item.estatus == 1" class="red--text">BAJA</span>
            <span v-if="item.estatus == 0" class="orange--text">INACTIVO</span>
          </template>

          <template v-slot:item.editar="{ item }" >
            <v-btn color="green darken-4" fab x-small dark class="ma-1" @click="editar(item)" >
              <v-icon >edit</v-icon>
            </v-btn>
            
         </template>
        </v-data-table>
      </v-card>
    </v-row>  
  </v-container>
</template>


<script>
  var md5 = require('md5')
  import saveAs from 'save-as'
  import XLSX from 'xlsx'


  export default {

    data: () => ({
      dialog: false,
      snackbar: false,
      color : 'red darken-4',
      text:'',

      headers: [
        { text: 'ID', align: 'left',sortable: false, value: 'idusuariosweb' },
        { text: 'Nombre'  , value: 'nombre' },
        { text: 'Apellidos'  , value: 'apellidos' },
        { text: 'Email'    , value: 'email' },
        { text: 'Nivel', value: 'nivel'},  
        { text: 'Estatus', value: 'estatus'},  
        { text: 'Acciones', value: 'editar'},  
      ],

      search: '',
      loading: false,
      usuarios: [],
           
    }),

    
    created () {
      this.init()
    },

    methods: {
       editar(item){
        this.$router.push({name:'newusuario', 
              params: {idusuariosweb: item.idusuariosweb}})
      },


      // EXCEL
      exportar(){
        var libro = []
        for(const i in this.usuarios){
          libro.push({
            Nombre: this.usuarios[i].nombre,
            Apellidos: this.usuarios[i].apellidos,
            Empresa: this.usuarios[i].empresa,
            Telefono_empresa: this.usuarios[i].telempresa,
            Telegono_movil: this.usuarios[i].telmovil,
            Email: this.usuarios[i].email,
            Modelo_maquina: this.usuarios[i].modmaquina,
            Matricula_Serie: this.usuarios[i].matserie,
            Nivel: this.usuarios[i].nivel,
          })
        }
        let data = XLSX.utils.json_to_sheet(libro)
        const workbook = XLSX.utils.book_new()
        const filename = 'Usuarios'
        XLSX.utils.book_append_sheet(workbook, data, filename)

        var wbout = XLSX.write(workbook, {
          bookType: 'xls',
          bookSST: false,
          type: 'binary'
        });

        const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
        // saveAs(new Blob([wbout],{type:"application/octet-stream"}), "usuarios.xls");
        let formData = new FormData();
        // //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file',file);
        // /*Initialize the form data*/
        console.log('formData', formData)
        this.$http.post('pdfs',formData).then(response=> {
          // alert(response.body)
          window.location = this.$http.options.root + 'pdfs/' + filename + '.xls'
        }).catch(error=> {
          alert(error.body)
          console.log(error);
        });
      },

      s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },



      cambiaEstatus(item,estatus){
        const payload = { id:item.idusuariosweb, estatus: estatus }
        this.$http.post('cambia.estatus',payload).then(response =>{
          this.snackbar=true; this.text=response.body; this.color="green"
          this.init();
        }).catch(err=>{
          console.log('errr',err)
        })
      },

      init () {
        //Consultar Usuarios
        this.loading = true
        this.$http.get('users').then( response => {
          this.usuarios= response.body
        }).catch(error => {
          console.log(error)
        }).finally(()  => this.loading = false) 

      },  



    },

  }
</script>